// @ts-nocheck
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { css } from "styled-components";

export const productListPaginationWrapperStyles = () => {
    return css`
        justify-content: center;

        &:not(#important) /* Override breakpoint values */ {
            ${({ theme }) => css`
                margin: ${theme.design.typography.spacing.base} 0;

                ${breakpoint("md")} {
                    margin: ${theme.design.typography.spacing.large} 0;
                }
            `}

            &:first-child {
                margin-top: 0;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }

        @media print {
            display: none;
        }
    `;
};
